import { PureComponent } from 'react';
import { string } from 'prop-types';

import { interpolatePath } from 'd3-interpolate-path';
import { easeCubicInOut } from 'd3-ease';
import { select } from 'd3-selection';
// d3-transition extends d3-selection with transition capabilities
import 'd3-transition';

/**
 * Draws a SVG path element and animates it when the props change.
 *
 * @author Nick Rutten <nick@cleverfranke.com>
 * @class AnimatedPath
 * @extends {PureComponent}
 */
class AnimatedPath extends PureComponent {
  componentDidUpdate({ pathString: prevPathString }) {
    const { pathString } = this.props;

    select(this.pathElement)
      .transition()
      .duration(200)
      .ease(easeCubicInOut)
      .attr('opacity', 1)
      .attrTween('d', () => interpolatePath(prevPathString, pathString));
  }

  componentDidMount() {
    const { pathString } = this.props;

    select(this.pathElement)
      .attr('d', pathString)
      .transition()
      .duration(200)
      .ease(easeCubicInOut)
      .attr('opacity', 1);
  }

  render() {
    const { ...presentational } = this.props;
    delete presentational.pathString;
    delete presentational.valueKey;

    return (
      <path
        opacity="0"
        ref={(ref) => (this.pathElement = ref)}
        {...presentational}
      />
    );
  }
}

AnimatedPath.propTypes = {
  /** A d-attribute path string, generated by a d3-shape generator.  */
  pathString: string,
};

export default AnimatedPath;
